import { useEffect, useState } from "react";
import { Package, Truck, Users, Container, FileText, MessageSquare, UserPlus, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

const STAT_ITEMS = [
  { k: "active_loads", label: "Active Loads", icon: Package },
  { k: "delivered", label: "Delivered", icon: CheckCircle2 },
  { k: "drivers", label: "Drivers", icon: Users },
  { k: "trucks", label: "Trucks", icon: Truck },
  { k: "trailers", label: "Trailers", icon: Container },
  { k: "new_quotes", label: "New Quotes", icon: FileText },
  { k: "new_applications", label: "New Applications", icon: UserPlus },
  { k: "new_messages", label: "New Messages", icon: MessageSquare },
];

export default function Overview() {
  const [data, setData] = useState({});
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <div className="font-mono-lt text-xs uppercase tracking-[0.3em] text-[var(--lt-accent-bright)] mb-2">// Dispatch Overview</div>
      <h1 className="font-display font-black text-4xl text-white uppercase mb-8">Operations Snapshot</h1>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
        {STAT_ITEMS.map((s) => (
          <div key={s.k} className="border border-[var(--lt-border)] bg-[var(--lt-panel)] p-5" data-testid={`stat-${s.k}`}>
            <s.icon className="h-5 w-5 text-[var(--lt-accent-bright)] mb-3" />
            <div className="text-xs font-mono-lt uppercase tracking-[0.2em] text-slate-500">{s.label}</div>
            <div className="font-display font-black text-3xl text-white mt-1">{data[s.k] ?? 0}</div>
          </div>
        ))}
      </div>

      <div className="border border-[var(--lt-border)] bg-[var(--lt-panel)]">
        <div className="p-5 border-b border-[var(--lt-border)]"><div className="font-head uppercase tracking-widest text-white text-sm">Recent Shipments</div></div>
        <div className="divide-y divide-[var(--lt-border)]">
          {(data.recent_shipments || []).length === 0 && <div className="p-6 text-sm text-slate-500">No shipments yet.</div>}
          {(data.recent_shipments || []).map((s) => (
            <div key={s.id} className="p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3 hover:bg-[var(--lt-panel-hover)]" data-testid={`recent-${s.id}`}>
              <div>
                <div className="font-mono-lt text-white text-sm">{s.load_number}</div>
                <div className="text-xs text-slate-500 mt-0.5">{s.pickup_location} → {s.delivery_location}</div>
              </div>
              <div className="inline-flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-[var(--lt-accent-bright)]" /><span className="font-head uppercase tracking-widest text-xs text-white">{s.status}</span></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
